<template>
  <dg-field-container :label_span="label_span" :field_span="field_span" :field_mark="field_mark"
                      :field_validate_message="validateMessage">
    <template v-slot:label>
      <dg-label-field :label="label" :translate="translateLabel" v-if='label'></dg-label-field>
    </template>
    <template v-slot:field>
      <el-radio :label="option.value" @change="updateValue" @input="updateValue" v-bind:key="key" v-for="(option, key) in options"
                v-model="field_value">{{ (translateLabels)?$ml.get(option.label): option.label }}
      </el-radio>
      <slot name="field_note"></slot>
    </template>
  </dg-field-container>
</template>

<script>
import inputField from '../mixins/inputField';

export default {
  mixins: [inputField],
  props: {
    options: {
      required: true,
      type: Array
    },
    translateLabels: {
      required: false,
      default: false
    },
  },
  data () {
    return {
      field_value: null,
      binding: 'radio'
    }
  }
}
</script>
